import React from 'react';
import PropTypes from 'prop-types';
import SelectComponent from 'pu-react/components/SelectComponent';
import RadioComponent from 'pu-react/components/RadioComponent';
import Label from 'pu-react/components/Label';

const PrototypeStencilType = (props) => {
  const {
    label,
    name,
    required,
    tooltip,
    groupName,
    onChangeParameter,
    variants,
    parameters,
    errorMessage,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);
  const options = {}

  if (variants && variants.length > 0) {
    variants.forEach((v) => {
      v.option_values.forEach((optionValue) => {
        const aditionalPrice = parseFloat(optionValue.aditional_price) || 0.0;
        if (optionValue.option_type_name === name) {
          options[optionValue.name] = `${optionValue.presentation}${aditionalPrice > 0 ? ` (+$${aditionalPrice})` : ''}`
        }
      })
    })
  }

  const items = Object.keys(options).map((value) => {
    const presentation = options[value]
    return (
      <RadioComponent
        key={value}
        name={name}
        inputId={`${groupName}-${name}-${value}`}
        label={presentation}
        checked={parameters[name] === value}
        value={value}
        onChange={onChange}
        groupName={groupName} />
    )
  })

  return (
    <div className="form-group">
      <Label label={label} required={required} />
      {items}
      {errorMessage}
    </div>

  )
}

PrototypeStencilType.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  groupName: PropTypes.string,
  parameters: PropTypes.object.isRequired,
  onChangeParameter: PropTypes.func.isRequired,
  variants: PropTypes.arrayOf(PropTypes.object).isRequired,
}

PrototypeStencilType.defaultProps = {
  label: 'Prototype Stencil Type',
  name: 'prototype_stencil_type',
  groupName: 'price_modifiers',
  required: true,
}
export default PrototypeStencilType;
